import { render, staticRenderFns } from "./BallSort.vue?vue&type=template&id=8b273856&scoped=true&"
import script from "./BallSort.vue?vue&type=script&lang=js&"
export * from "./BallSort.vue?vue&type=script&lang=js&"
import style0 from "./BallSort.vue?vue&type=style&index=0&id=8b273856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b273856",
  null
  
)

export default component.exports